export default __webpack_public_path__ + "static/media/clip.961a2cd0.mp4";